import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import { Button } from '@chakra-ui/react';
import { connect } from 'react-redux';

import css from './error-boundary.scss';
import { disableSpinner } from '../../containers/mle/mle-actions';
import { LEARNOSITY_SPINNER } from '../../helpers/constants';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error('Error caught by boundary:', error, errorInfo);
    this.props.disableLearnositySpinner();
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className={css['error-boundary']}>
          <div className={css['error-content']}>
            <h2 className={css['error-title']}>
              <Trans>Something went wrong</Trans>
            </h2>
            <p className={css['error-message']}>
              <Trans>Data not found</Trans>
            </p>
            <Button colorScheme="blue" onClick={() => window.history.back()}>
              <Trans>Back to Student Centre</Trans>
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  disableLearnositySpinner: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  disableLearnositySpinner: () => dispatch(disableSpinner(LEARNOSITY_SPINNER))
});

export default connect(null, mapDispatchToProps)(ErrorBoundary);
